import PropTypes from 'prop-types';
import React from 'react';
import { Chip } from '../../../../../../components/common/Chip';
import Tooltip from '../../../../../../components/common/Tooltip';
import Typography from '../../../../../../components/common/Typography';
import { emptyArray } from '../../../../../../utils/arrayUtils';
import { parseVendorTags } from '../../helpers';
import styles from '../../styles.module.css';

export default function TagsCell({ tags, onOpen }) {
  const tagsList = parseVendorTags(tags);

  if (emptyArray(tagsList)) {
    return <span>Not provided</span>;
  }

  const visibleTags = tagsList.slice(0, 2);
  const remainingTags = tagsList.slice(2);

  return (
    <button type="button" className={styles.tagsGroup} onClick={() => onOpen(tagsList)}>
      {visibleTags.map((tagName) => (
        <Chip key={tagName} label={tagName} size="small" variant="outlined" color="secondary" />
      ))}
      {remainingTags.length > 0 && (
        <Tooltip
          title={
            <Typography variant="body2" color="inherit">
              {remainingTags.join(', ')}
            </Typography>
          }
          placement="top"
        >
          <span className={styles.tagsMore}>+{remainingTags.length}</span>
        </Tooltip>
      )}
    </button>
  );
}

TagsCell.propTypes = {
  tags: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  onOpen: PropTypes.func.isRequired,
};
